import compose from "recompose/compose";
import branch from "recompose/branch";
import withProps from "recompose/withProps";
import { withRouter } from "react-router";
import { graphql } from "react-apollo";
import withProductAddedPopIn from "theme/modules/ProductAddedPopIn/withProductAddedPopIn";
import withEntityNotFound from "theme/modules/PageError/NotFound/withEntityNotFound";
import withErrorFallback from "theme/modules/PageError/withErrorFallback";

const EnhanceProduct = ({ ProductQuery }) =>
  compose(
    branch(
      (props) => props.product,
      (BaseComponent) => BaseComponent,
      compose(
        withRouter,
        withProps((props) => ({
          sku: props.sku || props.match.params.id,
        })),
        graphql(ProductQuery, {
          options: ({ sku }) => ({
            variables: {
              sku: sku,
            },
          }),
          props: ({ data }) => ({
            product: data.product,
            loading:
              data.loading ||
              (!data.error && typeof data.product === "undefined"),
            error: data.error,
          }),
        }),
        withErrorFallback({
          hasError: (props) => props.error,
        }),
        withEntityNotFound({
          isFound: (props) => props.error || props.loading || props.product,
        })
      )
    ),
    withProductAddedPopIn()
  );

export default EnhanceProduct;
